
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    // 是否使用灰色标题
    gray: {
      type: Boolean,
      default: false,
    },
    // 是否启用底部编剧
    bottom: {
      type: Boolean,
      default: false,
    },
    // 是否不显示标题边线
    borderDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const classNames = computed(() => {
      return {
        'card-gray': props.gray,
        'card-bottom': props.bottom,
        'card-header-border-none': props.borderDisabled,
      };
    });
    return {
      classNames,
    };
  },
});
